/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'
export type MapAlertDrawerTask_HubServiceNotification_Fragment = {
  __typename?: 'HubServiceNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_IvcTaskNotification_Fragment = {
  __typename?: 'IvcTaskNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
    id: string
    status: Types.TaskNotificationStatus
    createdAt: string
    severity: Types.TaskNotificationSeverity
    notificationType: Types.TaskNotificationType
    pended: {
      __typename?: 'TaskStateChangeDetails'
      timestamp: string | null
    } | null
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type MapAlertDrawerTask_PassengerUnbuckled_Fragment = {
  __typename?: 'PassengerUnbuckled'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_RoadBlockageTaskNotification_Fragment = {
  __typename?: 'RoadBlockageTaskNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_ShiftDeviationNotification_Fragment = {
  __typename?: 'ShiftDeviationNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_StopAccessibilityDownvotedByDrivers_Fragment = {
  __typename?: 'StopAccessibilityDownvotedByDrivers'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_StopActivationFailedNotification_Fragment = {
  __typename?: 'StopActivationFailedNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_StopAreaMissingActiveStopsNotification_Fragment =
  {
    __typename?: 'StopAreaMissingActiveStopsNotification'
    id: string
    status: Types.TaskNotificationStatus
    createdAt: string
    severity: Types.TaskNotificationSeverity
    notificationType: Types.TaskNotificationType
    pended: {
      __typename?: 'TaskStateChangeDetails'
      timestamp: string | null
    } | null
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUserId: string | null
    } | null
  }

export type MapAlertDrawerTask_StopDownVotedByDrivers_Fragment = {
  __typename?: 'StopDownVotedByDrivers'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_StopPotentiallyUnreachable_Fragment = {
  __typename?: 'StopPotentiallyUnreachable'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_StopValidationFailed_Fragment = {
  __typename?: 'StopValidationFailed'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_TimeManagementNotification_Fragment = {
  __typename?: 'TimeManagementNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_TripPrebookingNoAssignment_Fragment = {
  __typename: 'TripPrebookingNoAssignment'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  rejectionAt: string
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  trip: {
    __typename?: 'Trip'
    id: string
    customerV2: {
      __typename?: 'CustomerV2'
      id: string
      givenName: string | null
      familyName: string | null
      phoneNumber: string | null
    }
    pickup: {
      __typename?: 'TripTransferInformation'
      promisedTime: {
        __typename?: 'DateTimeInterval'
        from: string
        to: string
      }
    }
    seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
  } | null
  resolved: {
    __typename?: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
  } | null
  pickupStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en' | 'no', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
  dropoffStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en' | 'no', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type MapAlertDrawerTask_VehicleAvailabilityNotification_Fragment = {
  __typename?: 'VehicleAvailabilityNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_VehicleIncidentNotification_Fragment = {
  __typename?: 'VehicleIncidentNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTask_VehicleSurveillanceNotification_Fragment = {
  __typename: 'VehicleSurveillanceNotification'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  employee: {
    __typename?: 'Employee'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    highVoltageBatteryLevel: number | null
    cruisingRange: number | null
    totalPassengersInVehicle: number | null
    inService: boolean | null
    label: number | null
    licensePlate: string | null
    isSelfDriving: boolean
    hardwareConfiguration: {
      __typename?: 'HardwareConfiguration'
      tablet: { __typename?: 'Tablet'; phoneNumber: string | null } | null
    } | null
    fleet: { __typename?: 'Fleet'; id: string } | null
    lastVehicleInteraction: {
      __typename?: 'VehicleInteraction'
      type: Types.VehicleInteractionType
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type MapAlertDrawerTask_VehicleWaypointAttendance_Fragment = {
  __typename?: 'VehicleWaypointAttendance'
  id: string
  status: Types.TaskNotificationStatus
  createdAt: string
  severity: Types.TaskNotificationSeverity
  notificationType: Types.TaskNotificationType
  pended: {
    __typename?: 'TaskStateChangeDetails'
    timestamp: string | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
  } | null
}

export type MapAlertDrawerTaskFragment =
  | MapAlertDrawerTask_HubServiceNotification_Fragment
  | MapAlertDrawerTask_IvcTaskNotification_Fragment
  | MapAlertDrawerTask_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | MapAlertDrawerTask_PassengerUnbuckled_Fragment
  | MapAlertDrawerTask_RoadBlockageTaskNotification_Fragment
  | MapAlertDrawerTask_ShiftDeviationNotification_Fragment
  | MapAlertDrawerTask_StopAccessibilityDownvotedByDrivers_Fragment
  | MapAlertDrawerTask_StopActivationFailedNotification_Fragment
  | MapAlertDrawerTask_StopAreaMissingActiveStopsNotification_Fragment
  | MapAlertDrawerTask_StopDownVotedByDrivers_Fragment
  | MapAlertDrawerTask_StopPotentiallyUnreachable_Fragment
  | MapAlertDrawerTask_StopValidationFailed_Fragment
  | MapAlertDrawerTask_TimeManagementNotification_Fragment
  | MapAlertDrawerTask_TripPrebookingNoAssignment_Fragment
  | MapAlertDrawerTask_VehicleAvailabilityNotification_Fragment
  | MapAlertDrawerTask_VehicleIncidentNotification_Fragment
  | MapAlertDrawerTask_VehicleSurveillanceNotification_Fragment
  | MapAlertDrawerTask_VehicleWaypointAttendance_Fragment

export const MapAlertDrawerTaskFragmentDoc = gql`
    fragment MapAlertDrawerTask on TaskNotification {
  ...UseDisplayedAlertsTask
  ...AlertCardAlert
}
    `
